import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/.pnpm/next@15.5.7_@opentelemetry+api@1.9.0_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.7_@opentelemetry+api@1.9.0_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/public/images/logos/tigo/tigo-icon-terracotta .png");
